var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "选择任务",
        width: "1230px",
        loading: _vm.sureLoading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "selectTask" }, [
        _c("div", { staticClass: "filterHeader" }, [
          _c(
            "div",
            { staticClass: "filterRow" },
            [
              _c("span", { staticClass: "formLabel" }, [_vm._v("任务名称")]),
              _c("el-input", {
                staticClass: "m-r-10",
                staticStyle: { width: "200px" },
                attrs: {
                  size: "small",
                  placeholder: "请输入任务名称",
                  clearable: "",
                },
                on: { clear: _vm.searchFn },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchFn.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.search.taskName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.search,
                      "taskName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "search.taskName",
                },
              }),
              _c("span", { staticClass: "formLabel" }, [
                _vm._v("任务创建时间"),
              ]),
              _c("el-date-picker", {
                staticClass: "input-with-time m-r-10",
                attrs: {
                  size: "small",
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "unlink-panels": true,
                },
                on: { change: _vm.handleClickSearch },
                model: {
                  value: _vm.search.time.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.time, "value", $$v)
                  },
                  expression: "search.time.value",
                },
              }),
              _c("span", { staticClass: "formLabel" }, [_vm._v("创建人")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    filterable: "",
                    placeholder: "请选择",
                    clearable: "",
                  },
                  on: { change: _vm.searchFn },
                  model: {
                    value: _vm.search.userIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.search, "userIds", $$v)
                    },
                    expression: "search.userIds",
                  },
                },
                _vm._l(_vm.userArray, function (item) {
                  return _c("el-option", {
                    key: item.userId,
                    attrs: { label: item.nickName, value: item.userId },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "m-l-10",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.searchFn },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "myTable",
          },
          [
            _c("div", { staticClass: "taskLayout" }, [
              _c(
                "div",
                { staticClass: "taskLayout__left" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        height: "100%",
                        "header-cell-style": { background: "#F3F3F3" },
                        data: _vm.list,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { width: "80", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.selectIdsList.includes(row.id),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.rowClick(row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "任务名称",
                          prop: "taskName",
                          "min-width": "190px",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "创建人", prop: "createUserName" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "创建时间",
                          prop: "createTime",
                          "min-width": "152px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm
                                        .moment(row.createTime)
                                        .format("YYYY-MM-DD HH:mm:ss")
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c("div", { staticClass: "tipsError" }, [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v("已选" + _vm._s(_vm.selectList.length) + "项"),
                        ]),
                        _vm.selectList.length > 50
                          ? _c("span", { staticClass: "m-l-10" }, [
                              _vm._v("您关联的任务超过50个，请重新选择！"),
                            ])
                          : _vm._e(),
                      ]),
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total,
                          "pager-count": 5,
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.selectList.length
                ? _c(
                    "div",
                    { staticClass: "selectedTaskList taskLayout__right" },
                    [
                      _c("div", { staticClass: "selectedTaskList__title" }, [
                        _vm._v("已选任务"),
                      ]),
                      _c("div", { staticClass: "selectedTaskList__summary" }, [
                        _vm._v("已选 " + _vm._s(_vm.selectList.length) + " 项"),
                      ]),
                      _c("div", { staticClass: "selectedTaskTableHeader" }, [
                        _c(
                          "div",
                          { staticClass: "selectedTaskTableHeader__cell" },
                          [_vm._v("任务")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "selectedTaskTableHeader__cell selectedTaskTableHeader__follow",
                          },
                          [_c("span", [_vm._v("对应跟进人")])]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "selectedTaskList__body" },
                        _vm._l(_vm.selectedTasks, function (task) {
                          return _c(
                            "div",
                            {
                              key: task.id || task.taskId,
                              staticClass: "selectedTaskRow",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "selectedTaskRow__task" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      staticClass: "m-b-10",
                                      attrs: { closable: "", size: "small" },
                                      on: {
                                        close: function ($event) {
                                          return _vm.removeSelectedTag(task)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "selectedTaskNameText",
                                          attrs: { title: task.taskName },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(task.taskName) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "selectedTaskRow__follow" },
                                [
                                  task.followUserList &&
                                  task.followUserList.length
                                    ? _vm._l(task.followUserList, function (u) {
                                        return _c(
                                          "div",
                                          {
                                            key: `${task.id || task.taskId}-${
                                              u.followUserId || u.followUserName
                                            }`,
                                            staticClass: "followUserItem",
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "small" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      u.followUserName || "无"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "selectedTaskRow__followEmpty",
                                        },
                                        [_vm._v("无")]
                                      ),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          { staticClass: "ss-material-box-bottom" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.sure },
              },
              [_vm._v("确认")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeFn } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }